/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import TextField from '@molecules/TextField';
import { Button, Modal } from '@atoms';
import { Form } from '@organisms';

import { FORM_FIELD } from './constants';

export default function NameFormModal({ visible, onCancel, onSubmit, menuItem }) {
  const [nameForm] = Form.useForm();

  React.useEffect(() => {
    if (visible) nameForm.resetFields();
  }, [nameForm, visible]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={nameForm.submit}
      title="Edit label menu"
      footer={
        <>
          <Button key="submit" type="primary" onClick={nameForm.submit}>
            SAVE
          </Button>
          <Button key="cancel" onClick={onCancel}>
            CANCEL
          </Button>
        </>
      }
    >
      {menuItem && (
        <Form
          form={nameForm}
          initialValues={{ [FORM_FIELD.MENU_ITEM_TITLE.name]: menuItem.data.title }}
          onFinish={onSubmit}
          layout="vertical"
        >
          <TextField {...FORM_FIELD.MENU_ITEM_TITLE} />
        </Form>
      )}
    </Modal>
  );
}
